import React, { useEffect, useState } from "react";
import { Container, Label, Input, FormGroup } from "reactstrap";
import "../../share/form.css";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { utcToZonedTime } from 'date-fns-tz';
import DatePicker, { registerLocale } from "react-datepicker";
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";
import th from 'date-fns/locale/th';
import { th as thBuddhist } from 'date-fns/esm/locale';
import { format } from 'date-fns';
import { addYears } from 'date-fns/esm/fp';
import 'react-datepicker/dist/react-datepicker.css'
import Select from 'react-select';
import { GetVMdDept } from "../../share/api/MasterDataApi";
import { FormikSelect } from "../../share/FormikSelect";
import { Loading } from '../../share/loading'


export function Transferforofficer13Component() {
    const navigate = useNavigate();
    const [deptsData, setDeptsData] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const user = JSON.parse(localStorage.getItem("userData"));
    const [searchParams] = useSearchParams();
    const [selectedOptions, setSelectedOptions] = useState();

    registerLocale('th-buddhist', { ...th, options: { ...th.options, weekStartsOn: 1 }, formatLong: thBuddhist.formatLong })

    const range = (start, end) => {
        return new Array(end - start).fill().map((d, i) => i + start);
    };

    // const years = range(1990, getYear(new Date()));
    const years = range(1963, getYear(new Date()) + 8, 1);
    // const months = [
    //     {keyMonth:""}
    //     "January",
    //     "February",
    //     "March",
    //     "April",
    //     "May",
    //     "June",
    //     "July",
    //     "August",
    //     "September",
    //     "October",
    //     "November",
    //     "December"
    //   ];
    const thaiMonths = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
    ];
    // const months = [
    //     { value: "January", display: "มกราคม" },
    //     { value: "February", display: "กุมภาพันธ์" },
    //     { value: "March", display: "มีนาคม" },
    //     { value: "April", display: "เมษายน" },
    //     { value: "May", display: "พฤษภาคม" },
    //     { value: "June", display: "มิถุนายน" },
    //     { value: "July", display: "กรกฎาคม" },
    //     { value: "August", display: "สิงหาคม" },
    //     { value: "September", display: "กันยายน" },
    //     { value: "October", display: "ตุลาคม" },
    //     { value: "November", display: "พฤศจิกายน" },
    //     { value: "December", display: "ธันวาคม" },
    //   ];

    useEffect(() => {

        GetVMdDept({ setDeptsData, setLoading })

    }, []);





    const initialValues = {
        transferDate: "",
        transferAmount: "",
        Slipfile: "",
        TransferStatus: "1",
        deptId: "",
        supporttypeid: "11",
        budgetYear: "",
    };

    const validateSchema = Yup.object().shape({
        transferDate: Yup.string().required("กรุณาเลือกวันที่โอนเงิน"),
        transferAmount: Yup.string().required("กรุณากรอกจำนวนเงินที่โอน"),
        deptId: Yup.string().required("กรุณาเลือกหน่วยงาน"),
        budgetYear: Yup.string().required("กรุณาปีงบประมาณ"),
    });

    const onSubmit = async (
        values,
        { setFieldValue, setFieldError, setFieldTouched },
        actions
    ) => {
        // console.log("values", values)
        let postData = new FormData();
        Object.entries(values).forEach(([key, value]) => {
            postData.append(key, value);
        });
        try {
            let res = await fetch("/api/Support/savetransfer", {
                method: "POST",
                body: postData,
            });

            let resJson = await res.json();
            // console.log(resJson.dataenum);

            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    // title: "อัพเดทข้อมูลสำเร็จ",
                    text: "บันทึกข้อมูลสำเร็จ",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    if (result.isConfirmed) {
                        values.train === true ? navigate(`/supporting/`)
                            : navigate(`/supporting/`);
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        } catch (e) {
            // console.log("err =>", e)
        }

    };
    return (

        <Container className="d-flex justify-content-center align-items-center mt-2 mb-4 tab-container">
            <Formik
                initialValues={initialValues}
                validationSchema={validateSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {({ values, handleChange, handleBlur, setFieldValue, setValues, errors, touched }) => {
                    return (
                        <div className="form-border">
                            <Form className="p-5 mb-4">
                                <div className="mt-3 d-flex align-items-center justify-content-center">
                                    <Label
                                        style={{ fontWeight: "bold" }}
                                        className="customer-type text-center px-5"
                                    >
                                        แบบฟอร์มบันทึกข้อมูลรายละเอียดการจัดสรรเงินช่วยเหลือหรืออุดหนุน

                                    </Label>
                                </div>
                                <div className="mt-3 d-flex align-items-center justify-content-center">
                                    <span style={{ fontWeight: "bold" }} className="customer-type text-center px-5">ประจำปีงบประมาณ</span>
                                    <Field name={`budgetYear`}>
                                        {({ field, form, meta }) => (
                                            <Input
                                                disabled={values.changePlace === false}
                                                type="select"
                                                className={
                                                    meta.error && meta.touched
                                                        ? "input-error rounded-pill text-center input-color w-50"
                                                        : "rounded-pill text-center input-color w-50"
                                                }
                                                {...field}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                }}
                                            >
                                                <option defaultValue={"กรุณาเลือกปีงบประมาณ"}>
                                                    กรุณาเลือกปีงบประมาณ
                                                </option>
                                                <option value="2566">2566</option>
                                                <option value="2567">2567</option>
                                                <option value="2568">2568</option>
                                                <option value="2569">2569</option>
                                                <option value="2570">2570</option>
                                                <option value="2571">2571</option>
                                                <option value="2572">2572</option>

                                            </Input>
                                        )}

                                    </Field>

                                </div>
                                <div className="mt-3 d-flex align-items-center justify-content-between">
                                    <span>
                                        หน่วยงาน<span>*</span>
                                    </span>


                                    <Field
                                        name="deptId"
                                        component={FormikSelect}
                                        options={deptsData}
                                        placeholder={<div className="input-color text-center">กรุณาเลือกหน่วยงาน</div>}
                                    />



                                </div>
                                <div className="mt-3 d-flex align-items-center justify-content-between">
                                    <span>
                                        จัดสรรเงินช่วยเหลือหรืออุดหนุนตามประกาศ
                                    </span>
                                    <p className="w-50 p-2 rounded-pill text-center input-color border text-light bg-secondary">
                                        กรมพัฒนาฝีมือแรงงาน
                                    </p>
                                </div>
                                <FormGroup className="mt-3  d-flex align-items-center justify-content-between">

                                    <span >จำนวนเงินที่โอน</span>
                                    <Field name={`transferAmount`}>

                                        {({ field, meta }) => (
                                            <Input
                                                className={
                                                    meta.error && meta.touched
                                                        ? "input-error rounded-pill text-center input-color w-25"
                                                        : "rounded-pill text-center input-color w-25"
                                                }
                                                {...field}
                                            />
                                        )}
                                    </Field>
                                    <span>บาท</span>
                                    <div className="w-50 d-flex align-items-center justify-content-between">
                                        <span>วัน/เดือน/ปี ที่โอน</span>

                                        <Field name="transferDate">
                                            {({ field, meta, form }) => {
                                                const selectedDate = field.value ? utcToZonedTime(new Date(field.value), 'Asia/Bangkok') : null; // check if field.value is not null or undefined
                                                // console.log("sekect", selectedDate)
                                                const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null; // convert to Thai Buddhist
                                                const monthInThai = selectedDateInBE ? format(selectedDateInBE, 'MMMM', { locale: th }) : null;
                                                const formattedDate = selectedDateInBE ? format(selectedDateInBE, 'dd') + ' ' + monthInThai + ' ' + format(selectedDateInBE, 'yyyy') : null;

                                                const renderCustomHeader = ({ date,
                                                    changeYear,
                                                    changeMonth,
                                                    decreaseMonth,
                                                    increaseMonth,
                                                    prevMonthButtonDisabled,
                                                    nextMonthButtonDisabled, }) => {

                                                    return (

                                                        <div className=" w-100 react-datepicker__custom-header">
                                                            <div className="w-25 react-datepicker__custom-header-left">
                                                                <button
                                                                    type="button"
                                                                    className="react-datepicker__navigation react-datepicker__navigation--previous"
                                                                    aria-label="previous month"
                                                                    onClick={decreaseMonth}
                                                                    disabled={prevMonthButtonDisabled}
                                                                >
                                                                    <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous" />
                                                                </button>
                                                            </div>
                                                            <div className="w-50 react-datepicker__custom-header-center">
                                                                <div>
                                                                    {/* {format(date, 'MMMM', { locale: th })}{' '} */}
                                                                    <select
                                                                        value={thaiMonths[getMonth(date)]}
                                                                        onChange={({ target: { value } }) =>
                                                                            changeMonth(thaiMonths.indexOf(value))
                                                                        }
                                                                    >
                                                                        {thaiMonths.map(option => (
                                                                            <option key={option} value={option}>
                                                                                {option}
                                                                            </option>
                                                                        ))}
                                                                    </select>

                                                                    <select
                                                                        value={getYear(date)}
                                                                        onChange={({ target: { value } }) => changeYear(value)}
                                                                    >
                                                                        {years.map(option => (
                                                                            <option key={option} value={option}>
                                                                                {Number(option) + 543}
                                                                            </option>
                                                                        ))}
                                                                    </select>


                                                                </div>
                                                            </div>
                                                            <div className="w-25 react-datepicker__custom-header-right">
                                                                <button
                                                                    type="button"
                                                                    className="react-datepicker__navigation react-datepicker__navigation--next"
                                                                    aria-label="next month"
                                                                    onClick={increaseMonth}
                                                                    disabled={nextMonthButtonDisabled}
                                                                >
                                                                    <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    );
                                                };



                                                return (
                                                    <DatePicker

                                                        selected={selectedDate}
                                                        locale="th-buddhist"
                                                        calendarClassName="thai-buddhist"
                                                        dateFormat="dd MMMM yyyy"
                                                        value={formattedDate}
                                                        isClearable={true}
                                                        placeholderText="กรุณาเลือก"
                                                        renderCustomHeader={renderCustomHeader}
                                                        onChange={(date) => {
                                                            if (date instanceof Date && !isNaN(date)) {
                                                                // const isoDate = date.toISOString().substring(0, 10)
                                                                // console.log("iso",typeof(isoDate))
                                                                const year = date.getFullYear();
                                                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                                                const day = String(date.getDate()).padStart(2, '0');
                                                                const formattedDate = `${year}-${month}-${day}`;
                                                                // console.log("format", typeof (formattedDate))
                                                                form.setFieldValue(field.name, formattedDate);
                                                            } else {
                                                                form.setFieldValue(field.name, "");
                                                            }
                                                        }}
                                                        customInput={
                                                            <Input
                                                                type="text"
                                                                className={
                                                                    meta.error && meta.touched
                                                                        ? "w-100 input-error rounded-pill text-center input-color"
                                                                        : "w-100 rounded-pill text-center input-color"
                                                                }
                                                                value={formattedDate}
                                                                onChange={() => { }}
                                                                onBlur={field.onBlur}
                                                            />
                                                        }
                                                    />
                                                )
                                            }}
                                        </Field>
                                    </div>
                                </FormGroup>
                                <FormGroup className="mt-3 d-flex align-items-start justify-content-center flex-column ">
                                    <span className="">เอกสารอื่นๆ(ถ้ามี)</span>
                                    <Input
                                        name="Slipfile"
                                        type="file"
                                        className="mt-2 rounded-pill text-center input-color w-100"


                                        onBlur={handleBlur}
                                        onChange={(e) => {
                                            handleChange(e)
                                            if (e.target && e.target.files[0]) {
                                                setFieldValue(`Slipfile`, e.target.files[0]);
                                            }
                                        }}
                                    />

                                </FormGroup>
                                <div className="mt-3 d-flex align-items-center justify-content-center flex-column ">
                                    <button type="submit" className="p-1 bg-primary rounded-pill w-25 text-white border-0">บันทึก</button>
                                </div>
                            </Form>
                        </div>
                    )
                }}
            </Formik>
        </Container>
    )
}